// extracted by mini-css-extract-plugin
export var error = "ResetPassword-module--error--p-S3g";
export var welcomeContent = "ResetPassword-module--welcomeContent--D9xx7";